export const SCRIBE_SUGGESTION_MARKER_PROPERTY = 'isScribeSuggested' as const;

export type ScribeSuggestionFieldMarkers = Record<string, true>;

export type ScribeSuggestionMarker = true | ScribeSuggestionFieldMarkers;

export type ScribeSuggestionMarkerTarget = Record<string, unknown> & {
  [SCRIBE_SUGGESTION_MARKER_PROPERTY]?: ScribeSuggestionMarker;
};
